export { default } from './FormControl';
export { default as useFormControl } from './useFormControl';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/FormControl/index.js
// module id = 312
// module chunks = 121